import { Features } from "../../../Enums/companyStatus";

export interface VoicesNavigationItem {
  path: string;
  labelKey: string;
  features: Features[];
}

export const VOICES_FEATURES = [
  Features.VOICES_MARKETING,
  Features.VOICES_POSTING,
];

export const voicesNavigation: VoicesNavigationItem[] = [
  { path: "/voices/today", labelKey: "navigation.today", features: VOICES_FEATURES },
  {
    path: "/voices/campaigns",
    labelKey: "navigation.campaigns",
    features: VOICES_FEATURES,
  },
  { path: "/voices/posts", labelKey: "navigation.posts", features: VOICES_FEATURES },
  {
    path: "/voices/calendar",
    labelKey: "navigation.calendar",
    features: VOICES_FEATURES,
  },
  {
    path: "/voices/engage",
    labelKey: "navigation.engage",
    features: VOICES_FEATURES,
  },
  {
    path: "/voices/results",
    labelKey: "navigation.results",
    features: VOICES_FEATURES,
  },
  {
    path: "/voices/profile",
    labelKey: "navigation.profile",
    features: [Features.VOICES_POSTING],
  },
  {
    path: "/voices/people",
    labelKey: "navigation.people",
    features: [Features.VOICES_MARKETING],
  },
  {
    path: "/voices/usage",
    labelKey: "navigation.usage",
    features: [Features.VOICES_MARKETING],
  },
  {
    path: "/voices/settings",
    labelKey: "navigation.settings",
    features: [Features.VOICES_MARKETING],
  },
];
